module.exports = __webpack_public_path__ + "static/media/custom.27c68284.svg";